// Room/pax (de)serialization.
//
// Rooms are encoded as a compact, hyphen-joined string for the booking engine
// URL - one segment per room: "A2C5C7I1" = 2 adults, children aged 5 and 7,
// 1 infant. Multiple rooms join with "-": "A2-A2C10".

export const DEFAULT_ROOMS = [{ adults: 2, children: [], infants: 0 }];

export const serializeRooms = (rooms) => {
    const roomDefs = [];
    for (let i = 0; i < rooms.length; i++) {
        const room = rooms[i];
        let myUrlSlug = `A${room.adults}`;
        if (room.children.length > 0) {
            for (let c = 0; c < room.children.length; c++) {
                myUrlSlug = myUrlSlug + `C${room.children[c]}`;
            }
        }
        if (room.infants > 0) {
            myUrlSlug = myUrlSlug + `I${room.infants}`;
        }
        roomDefs.push(myUrlSlug);
    }
    return roomDefs.join('-');
};

export const deserializeRooms = (roomsString) => {
    if (!roomsString) {
        return DEFAULT_ROOMS;
    }

    const roomDefs = roomsString.split('-');
    const rooms = [];

    for (let i = 0; i < roomDefs.length; i++) {
        const roomDef = roomDefs[i];
        const room = { adults: 0, children: [], infants: 0 };

        // Match pattern: A2C5C7I1 (adults, children with ages, infants)
        const adultsMatch = roomDef.match(/A(\d+)/);
        const childrenMatches = roomDef.matchAll(/C(\d+)/g);
        const infantsMatch = roomDef.match(/I(\d+)/);

        if (adultsMatch) {
            room.adults = parseInt(adultsMatch[1], 10);
        }

        for (const childMatch of childrenMatches) {
            room.children.push(parseInt(childMatch[1], 10));
        }

        if (infantsMatch) {
            room.infants = parseInt(infantsMatch[1], 10);
        }

        rooms.push(room);
    }

    return rooms;
};

// A villa is one booking for the whole party, so the Villas tab has no rooms: several
// rooms (kept from another tab) merge into one party.
export const toSingleParty = (rooms) => {
    if (!rooms || rooms.length <= 1) {
        return rooms && rooms.length == 1 ? rooms : DEFAULT_ROOMS;
    }
    return [{
        adults: rooms.reduce((sum, room) => sum + room.adults, 0),
        children: rooms.flatMap((room) => room.children),
        infants: rooms.reduce((sum, room) => sum + room.infants, 0),
    }];
};
